import { ComponentProjectDetailPageState } from ".";

export const ComponentProjectDetailPageInitialState: ComponentProjectDetailPageState =
  {
    searchResult: {
      cmpPjtInfo: {
        cpntPjtTypeCd: "",
        cpntPjtTypeName: "",
        pjtName: "",
        pjtSts: "",
        pjtStsDsplyName: "",
        dipByRgn: "",
        rootCpntId: "",
        cpntId: "",
        cpntName: "",
        cpntPrtclCtgryTypeCd: "",
        inOutTypeCd: "",
        inOutTypeName: "",
        prtcolTypeCd: "",
        prtcolTypeName: "",
        ptnrId: "",
        ptnrName: "",
        delPjtFlg: "",
        stgOnlyFlg: "",
        othrStgStupFlg: "",
        stgSchedDplymntDate: "",
        prdSchedDplymntDate: "",
        stgIfdDplymntPsblFlg: "",
        prdIfdDplymntPsblFlg: "",
        reqTskSlctdFlg: "",
        updateDateTime: "",
      },
      stkhldrs: [],
      relatedIfPjts: [],
      cpntAttrStatus: {
        dsgnTcktId: "",
        dsgnSts: "",
        dsgnStsDsplyName: "",
        stgDplymntTcktId: "",
        stgDplymntSts: "",
        stgDplymntStsDsplyName: "",
        prdDplymntTcktId: "",
        prdDplymntSts: "",
        prdDplymntStsDsplyName: "",
      },
      stupTaskCtgries: [],
      stupTasks: [],
      stupTckts: [],
      mmTxt: "",
      mmTxtUpdateDateTime: "",
    },
    dataList: {
      inDefCommonFlagType: [],
      roleType: [],
    },
    projectInformation: {
      cpntPjtTypeCd: "",
      cpntPjtTypeName: "",
      pjtName: "",
      pjtSts: "",
      pjtStsDsplyName: "",
      dipByRgn: "",
      rootCpntId: "",
      cpntId: "",
      cpntName: "",
      cpntPrtclCtgryTypeCd: "",
      inOutTypeCd: "",
      inOutTypeName: "",
      prtcolTypeCd: "",
      prtcolTypeName: "",
      ptnrId: "",
      ptnrName: "",
      delPjtFlg: "",
      stgOnlyFlg: "",
      othrStgStupFlg: "",
      stgSchedDplymntDate: "",
      prdSchedDplymntDate: "",
      stgIfdDplymntPsblFlg: "",
      prdIfdDplymntPsblFlg: "",
      reqTskSlctdFlg: "",
      updateDateTime: "",
    },
    stakeholders: {
      dipFr: "",
      dipApp: "",
      dipInfra: "",
      bizApproval: "",
      bizInCharge: "",
      bizInfra: "",
    },
    componentAttributeStatus: {
      dsgnTcktId: "",
      dsgnSts: "",
      dsgnStsDsplyName: "",
      stgDplymntTcktId: "",
      stgDplymntSts: "",
      stgDplymntStsDsplyName: "",
      prdDplymntTcktId: "",
      prdDplymntSts: "",
      prdDplymntStsDsplyName: "",
    },
    primarySortingCompletionFlag: false,
    secondarySortingCompletionFlag: false,
  };
